export default {
    estateSession: {
        estatePlanningSession: '遺產規劃會議',
        estatePlanningSessionDescription: '透過視像通話與我們的遺囑專家進行私人諮詢，協助您規劃遺產事宜。此諮詢服務不包含遺囑訂立——您可以將其作為獨立的第一步，先獲取專業意見，或與我們的遺囑產品同步使用。若您其後決定採用我們的高級服務，此諮詢費用將從總費用中扣除。',
        estatePlanningSessionIdealFor1: '需要額外指導和支援的客戶',
        estatePlanningSessionIdealFor2: '擁有海外資產，包括稅務考量',
        estatePlanningSessionIncludes1: '討論遺囑執行人、監護人及資產分配；',
        estatePlanningSessionIncludes2: '審閱您的資產清單及遺產規劃詳情；',
        estatePlanningSessionIncludes3: '就您的海外資產提供指導',
        estatePlanningSessionIncludes4: '對您的遺囑作出小幅調整',
        productSub: '首次使用客戶',
        productSub2: '回訪客戶',
    },
};
